import { render, staticRenderFns } from "./usageAgreement.vue?vue&type=template&id=ec0b4776&scoped=true"
var script = {}
import style0 from "./usageAgreement.vue?vue&type=style&index=0&id=ec0b4776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0b4776",
  null
  
)

export default component.exports